// extracted by mini-css-extract-plugin
module.exports = {"root":"projects_view_banner_root__2OvgC","image":"projects_view_banner_image__1Lmdy"};